<template>
  <div>
    <div v-if="json" class="">
      <v-card flat class="pa-4 blueCard mb-4">
        <h3>{{ json.title }}</h3>
        <div class="subtitle" v-html="json.description"></div>
      </v-card>
      <div v-for="(section, index) in json.sections" :key="index">
        <v-card flat color="#fff9ec" class="mb-4">
          <v-card-title>
            {{ section.name }}
          </v-card-title>
          <v-card-text>
            <v-list style="background-color: transparent">
              <v-list-item-group>
                <v-list-item
                  v-for="(item, i) in section.items"
                  :key="i"
                  nav
                  :to="urlForItem(item)"
                >
                  <v-list-item-icon>
                    <v-icon v-if="item.icon" color="primary"
                      >mdi-{{ item.icon }}</v-icon
                    >
                    <v-img
                      v-else-if="item.image"
                      :src="imgPath + item.image"
                      height="24px"
                      width="24"
                      contain
                    ></v-img>
                    <v-icon v-else color="primary"
                      >mdi-clipboard-text-outline</v-icon
                    >
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ item.name }}
                      <span v-if="item.pro && !isSubscribed" class="pro ml-2"
                        >PRO</span
                      > </v-list-item-title
                    ><v-list-item-subtitle
                      v-if="item.description"
                      v-html="item.description"
                    ></v-list-item-subtitle>
                    <v-list-item-subtitle
                      v-if="item.pro && !isSubscribed"
                      class="primary--text"
                      >Learn More</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <div v-else>Loading</div>
  </div>
</template>

<script>
import GetJsonMixin from "@/assets/js/GetJsonMixin";
import UserMixin from "@/assets/js/UserMixin";

export default {
  name: "CodesHome",
  mixins: [GetJsonMixin, UserMixin],
  props: {},
  data: function () {
    return { json: null, imgPath: "https://www.eyedock.com/images/" };
  },
  methods: {
    urlForItem(itemObj) {
      if (this.isSubscribed || !itemObj.pro) return itemObj.path;
      if (itemObj.pro && !this.isSubscribed && itemObj.moreInfo)
        return itemObj.moreInfo;
      return null;
    },
  },
  computed: {},
  mounted() {
    this.getJSON("dxAndBillCodeMenu"); // from the mixin
    // just to un-highlight any billing codes menu item
  },
  metaInfo() {
    return {
      title: "EyeDock/Billing | Coding Widget",
    };
  },
};
</script>

<style scoped>
.pro {
  color: red;
  font-variant: small-caps;
  font-size: 8pt;
  font-weight: bold;
}
</style>
